/* type information for all variants & any component-specific prop types or enums go in this file */
export var SEOLinkType;

(function (SEOLinkType) {
  SEOLinkType["Eyebrow"] = "Eyebrow";
  SEOLinkType["Subject"] = "Subject";
  SEOLinkType["SubSubject"] = "SubSubject";
})(SEOLinkType || (SEOLinkType = {}));